import { getLanguage } from '../utils/locale';
import serverApi from './index';

export const fetchPreloadData = () =>
  serverApi.get(`/front`, {
    params: {
      language: getLanguage(),
      [Math.random()]: 'uniq'
    }
  });
